import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './components/reports/reports.component';
import { AccountsReportsComponent } from './components/tabs/accounts/accounts.component';
import { ManagersRetailComponent } from './components/tabs/managers-retail/managers-retail.component';
import { ManagersOverviewComponent } from './components/tabs/managers-overview/managers-overview.component';
import { GamedaySharedModule } from '../shared/shared.module';
import { SharedModule } from '@ipreo/muni-shared';
import { AgGridModule } from 'ag-grid-angular';

export const agGridModule = AgGridModule.withComponents([]);

@NgModule({
  imports: [CommonModule, SharedModule, agGridModule, GamedaySharedModule],
  declarations: [
    ReportsComponent,
    AccountsReportsComponent,
    ManagersRetailComponent,
    ManagersOverviewComponent,
  ],
  exports: [ReportsComponent],
  providers: [],
})
export class ReportsModule {}
